import { render, staticRenderFns } from "./CustomColumns.vue?vue&type=template&id=13b1eb7a&scoped=true"
import script from "./CustomColumns.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomColumns.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomColumns.vue?vue&type=style&index=0&id=13b1eb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b1eb7a",
  null
  
)

export default component.exports